import { render, staticRenderFns } from "./Screenshot.vue?vue&type=template&id=06b3ae00&scoped=true"
import script from "./Screenshot.vue?vue&type=script&lang=js"
export * from "./Screenshot.vue?vue&type=script&lang=js"
import style0 from "./Screenshot.vue?vue&type=style&index=0&id=06b3ae00&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b3ae00",
  null
  
)

export default component.exports